
namespace TabAurous.ProductDevelopment {

    @Serenity.Decorators.registerClass()
    export class RequirementItemsGrid extends _Ext.GridBase<RequirementItemsRow, any> {
        protected getColumnsKey() { return 'ProductDevelopment.RequirementItems'; }
        protected getDialogType() { return RequirementItemsDialog; }
        protected getIdProperty() { return RequirementItemsRow.idProperty; }
        protected getInsertPermission() { return RequirementItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return RequirementItemsRow.localTextPrefix; }
        protected getService() { return RequirementItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);

        }

        protected addButtonClick() {

            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(101);
            var userDefinition = Q.Authorization.userDefinition;
            var refno = FormatHelper.GetFormats("RefNo");
            //this.form.RefNo.value = refno;
            //let refno = "";
            //Common.CommonService.GetNextNumbers({ Prefix: 'C51000_', Length: 10 }, response => {
            //    if (response != null) {
            //        refno = response.Serial;
            //    }
            //}, { async: false });
            this.editItem(<RequirementItemsRow>{
                VoucherTypeId: 101,
                UserId: userDefinition.UserId,
                Iteration: "01",
                RefNo: refno
            });
        }
    }
}